import React from 'react'
import { Segment } from 'semantic-ui-react'

const Loading = ({}) => <Segment basic loading style={{ marginTop: '60px' }} />

export default Loading
